import { useEffect,useState } from 'react';
import { KTIcon } from '../../../../_metronic/helpers';
import axios from 'axios';
import { DevicesForti } from './components/ModalDevicesForti';
import { getlistDevice} from '../entitlements/request/request';
import { useAppSelector } from '../../../../redux/hooks';
import Swal from 'sweetalert2';
import { useAuth } from '../../auth';
import Spinner from '../../custom/Spinner/Spinner';
import { Demodevice } from './components/ModalDemoDevice';

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number |string

type num= number

/******************aqui e realizaron cambios en filtro aws y azr poc b************************** */

function FortiDevicesCrud() {
    const{currentUser}= useAuth()
    const tenant= useAppSelector(state =>state.TenantSlice.id)
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const Type = useAppSelector(state => state.CloudSlice.Type)



    /* variable para el modal  */
    const [ ID , setID]=useState<ID>(undefined)

    const [fw,setnumb]=useState<num>()
    /*__________________________*/

    const [records,setRecords]= useState<any|null>([ ])
    const [autoreload,setautoreload]=useState(false)

    


    /**********************Llamada a axios y parse de data**********************/

    useEffect( () => {
        if (currentUser?.ListPermiso?.includes('Ctx.NGFW.List') &&Type!=='Global' &&Id!==0){
         if(tenant ===0){
            getlistDevice(Id).then(response=>{
                setRecords(response.data)
            })
         }
         else if(tenant !==0){
            getlistDevice(Id).then(response=>{
                setRecords(response.data)
            })
         }
        }
        
        }, [tenant,Id,Type])

    /********************global**************************** */
    useEffect( () => {
        if (currentUser?.ListPermiso?.includes('Ctx.NGFW.List')&&Type==='Global' &&Id===0){
         if(tenant ===0){
            getlistDevice(19).then(response=>{
                setRecords(response.data)
            })
         }
         else if(tenant !==0){
            getlistDevice(19).then(response=>{
                setRecords(response.data)
            })
         }
        }
        
        }, [tenant,Id])
     

    /***********************************************************************************/
    const [loading,setload]= useState(false)
    function reloaddevice(){
        setload(true)
        if (currentUser?.ListPermiso?.includes('Ctx.NGFW.List')&& Id!==0&& Type!=='Global'){
        if(tenant ===0){
            getlistDevice(Id).then(response=>{
                setRecords(response.data)
                setload(false)

            })
         }
         else if(tenant !==0){
            getlistDevice(Id).then(response=>{
                setRecords(response.data)
                setload(false)

            })
         }
        }
        if (currentUser?.ListPermiso?.includes('Ctx.NGFW.List')&& Id===0&& Type==='Global'){
            if(tenant ===0){
                getlistDevice(19).then(response=>{
                    setRecords(response.data)
                    setload(false)

                })
             }
             else if(tenant !==0){
                getlistDevice(19).then(response=>{
                    setRecords(response.data)
                    setload(false)

                })
             }
            }
    }
    /************************AUTORELOAD***************************** 
    useEffect(() => {
        let interval: NodeJS.Timeout | undefined = undefined;

        const fetchData = async () => {
            const response = await getlistDevice(Id);
            setRecords(response.data);
            // Verifica si algún dispositivo tiene el estado "ready"
            const isReady = response.data.some((d: any) => d.status === 'ready');
            if (isReady ) {
                if (interval) {
                    clearInterval(interval);
                    interval = undefined;
                }
                setautoreload(false);
            }
        };

        const startInterval = () => {
            interval = setInterval(fetchData, 10000); // Llama a fetchData cada 10 segundos
        };

        const stopInterval = () => {
            if (interval) {
                clearInterval(interval);
                interval = undefined;
            }
        };

        if (autoreload) {
            fetchData(); // Llama a fetchData inmediatamente
            startInterval(); // Comienza el intervalo
        } else {
            stopInterval(); // Detiene el intervalo si autoreload es false
        }

        return stopInterval; // Limpia el intervalo cuando el componente se desmonta o autoreload cambia a false
    }, [autoreload, Id]);*/

    useEffect(() => {
        let intervalId: any; // Declarar el tipo de intervalId
    
        if (autoreload) {
            
            const fetchDeviceList = () => {
                getlistDevice(Id).then(response => {
                    setRecords(response.data);
                    const isReady = response.data.some((d: any) => d.status === 'ready');
                    
                    if (isReady) {
                        clearInterval(intervalId);
                        setautoreload(false);
                       
                        getlistDevice(Id).then(response=>{
                            setRecords(response.data)            
                        })

                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Your Device Is Ready',
                            text:'See your Credentials in Actions/Password',
                            showConfirmButton: false,
                            timer: 1500
                          })
                    }
                });
            };
    
            fetchDeviceList(); // Llama a fetchDeviceList inmediatamente al iniciar
    
            // Establece un intervalo para llamar a fetchDeviceList cada 10 segundos
            intervalId = setInterval(fetchDeviceList, 10000);
        }
    
        // Limpia el intervalo cuando el componente se desmonta
        return () => clearInterval(intervalId);
    }, [autoreload, Id]); // Dependencias del efecto

    useEffect(() => {
        // Código que deseas ejecutar
      if (Type){
        setRecords([])
      }
        
      }, [Type]);

    return(
        <>
        {loading&&<Spinner></Spinner>}
        <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>Device Management</span>
            </h3>
            {/*Se agrega Boton para agregar usuarios*/}
            <div className="d-flex align-items-center">
            {currentUser?.ListPermiso?.includes('Ctx.NGFW.Add') && <button onClick={ () => setID(null)} className='btn-light-marino f-parrafo'>CREATE</button>}
            <button className="btn-light-marino f-parrafo" style={{marginLeft:'10px'}} onClick={reloaddevice}>
                <i className="text-gray-100 bi bi-arrow-clockwise"></i>
            </button>
            </div>
        </div>



        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
            <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                {/* begin::Table container */}
                <div className='table-responsive'>

                {/* begin::Table */}
                    <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                        {/* begin::Table head */}
                        <thead>
                
                            <tr className="table-header-light bg-marino">
                                <th className='table-cell'>Name</th>
                                <th className='table-cell'>VCPU</th>
                                <th className='table-cell'>Memory</th>
                                <th className='table-cell'>Entitlement</th>
                                <th className='table-cell'>Status</th>
                                <th className='table-cell'>Manage</th>
                                <th className='table-cell'>Credentials </th>



                            </tr>
                        </thead>
                        {/* end::Table head */}


                        {/* begin::Table body */}
                        <tbody>
                            {records.map((d:any,i:any)=>(
                                    <tr key={i} className='table-row'> 
                           
                                        {d.name.includes(Type)&&<td className='table-cell'>{d.name}</td>}
                                        {d.name.includes(Type)&&<td className='table-cell'>{d.vcpu}</td>}
                                        {d.name.includes(Type)&&<td className='table-cell'>{d.ram}</td>}
                                        {d.name.includes(Type)&&<td className='table-cell'>{d.nameconfig}</td>}
                                        {d.name.includes(Type)&&<td className='table-cell'>
                                            {d.status==='deploying'&& <div className="badge-deploying">{d.status}<span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                            {d.status==='starting'&& <div className="badge-starting">{d.status}<span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                            {d.status==='configuring'&& <div className="badge-configuring">{d.status}<span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                            {d.status==='ready'&& <div className="badge-ready">{d.status}</div>}
                                            {d.status==='removing'&& <div className="badge-removing">{d.status} <span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                        </td>}
                                        {currentUser?.is_demo!==true&& d.status==='ready'&&d.name.includes(Type)&&
                                        
                                        <td className='table-cell'>
                                        <a className="btn-light-marino f-parrafo" href={'https://ngfw.transitxchange.cloud/'+ d.url} target="_blank">
                                                <i className="text-pink bi bi-arrow-up-right-square"></i>
                                            </a>
                                           
                                        </td>}

                                        {currentUser?.is_demo!==true&& d.status!=='ready'&&
                                        <td className='table-cell'>---</td>}

                                        {currentUser?.is_demo===true&& 
                                        <td className='table-cell'>
                                            <button className="btn-light-marino f-parrafo"  onClick={ () => setID('demo')} >
                                                <i className="text-pink bi bi-arrow-up-right-square"></i>
                                            </button>
                                        </td>
                                        }

                                        {d.name.includes(Type)&&<td className='table-cell'>
                                        { currentUser?.ListPermiso?.includes('Ctx.NGFW.Update') && <div className='menu-item px-3 text-secondary'>
                                                <button className='btn-light-marino f-parrafo' 
                                                    
                                                    onClick={() => (setID('password'), setnumb(d.id))}>
                                                    Password
                                                </button>
                                                </div>}
                                        </td>}

                                   
                                    </tr>
                                ))
                            }
                            
                           
                        </tbody>

                        {Type==='Global'&&
                            <tbody>
                            {records.map((d:any,i:any)=>(
                                    <tr key={i} className='table-row'> 
                        
                                        {<td className='table-cell'>{d.name}</td>}
                                        {<td className='table-cell'>{d.vcpu}</td>}
                                        {<td className='table-cell'>{d.ram}</td>}
                                        {<td className='table-cell'>{d.nameconfig}</td>}
                                        {<td className='table-cell'>
                                            {d.status==='deploying'&& <div className="badge-deploying">{d.status}<span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                            {d.status==='starting'&& <div className="badge-starting">{d.status}<span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                            {d.status==='configuring'&& <div className="badge-configuring">{d.status}<span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                            {d.status==='ready'&& <div className="badge-ready">{d.status}</div>}
                                            {d.status==='removing'&& <div className="badge-removing">{d.status} <span className='spinner-border spinner-border-sm align-middle ms-2'></span></div>}
                                        </td>}
                                        {currentUser?.is_demo!==true&& d.status==='ready'&&
                                        
                                        <td className='table-cell'>
                                        <a className="btn-light-marino f-parrafo" href={'https://ngfw.transitxchange.cloud/'+ d.url} target="_blank">
                                                <i className="text-pink bi bi-arrow-up-right-square"></i>
                                            </a>
                                        
                                        </td>}

                                        {currentUser?.is_demo!==true&& d.status!=='ready'&&
                                        <td className='table-cell'>---</td>}

                                        {currentUser?.is_demo===true&& 
                                        <td className='table-cell'>
                                            <button className="btn-light-marino f-parrafo"  onClick={ () => setID('demo')} >
                                                <i className="text-pink bi bi-arrow-up-right-square"></i>
                                            </button>
                                        </td>
                                        }

                                        <td className='table-cell'>
                                        { currentUser?.ListPermiso?.includes('Ctx.NGFW.Update') && <div className='menu-item px-3 text-secondary'>
                                                <button className='btn-light-marino f-parrafo' 
                                                    
                                                    onClick={() => (setID('password'), setnumb(d.id))}>
                                                    Password
                                                </button>
                                                </div>}
                                        </td>

                                       
                                    </tr>
                                ))
                            }
                            
                        
                        </tbody>
                        }
                          {/* end::Table body */}

                    </table>
                     {/* end::Table */}
                </div>
               

            </div>
            {/* end::Tap pane */}
            </div>
        </div>
        <br />
        {/* end::Body */}
        </div>
        
        {ID !== undefined && <DevicesForti setID={setID} id={ID} fw={fw} setautoreload={setautoreload}/>}
        {ID !== undefined && <Demodevice setID={setID} id={ID} />}


        
        </>

	);
    function deletedevice(id:any){
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this Device!",
            showCancelButton:true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          })
          .then((result) => {
            if (result.isConfirmed) {
                if(tenant===0){
                    axios.delete(API_URL+'/v1/fw/'+Id+'/'+id)
                    .then(res=>{
                    if  (res.data.status==='removing'){
                    Swal.fire(
                        'Deleted!',
                        'Your device is being deleted.',
                        'success'
                    );}
                    else{
                        Swal.fire(
                            'error!',
                            'Your Device could not be eliminated!',
                            'error'
                        );
                    }
                    getlistDevice(Id).then(response=>{
                        setRecords(response.data)
                    })
                })
                   

                }
                else{
                    axios.delete(API_URL+'/v1/fw/'+Id+'/'+id)
                    .then(res=>{
                        if  (res.data.status==='removing'){
                            Swal.fire(
                                'Deleted!',
                                'Your device is being deleted.',
                                'success'
                            );}
                            else{
                                Swal.fire(
                                    'error!',
                                    'Your Device could not be eliminated!',
                                    'error'
                                );
                            }
                     getlistDevice(Id).then(response=>{
                        setRecords(response.data)
                    })
                })
                
                }
             
            } else {
              Swal.fire({title:"Your Device is safe!", icon: "success"});
            }
          });
        
        
    }
    }

export default FortiDevicesCrud